import { hyperdbTriggers } from 'hyperdb-utils';
import * as config from '../../config';

export default hyperdbTriggers({ config,
  triggerName: 'wizard',
  namespace: 'WIZARD',
  entryPoint: '/init-wizard',
});



// WEBPACK FOOTER //
// ./src/frontend/init-wizard/triggers.js